import {
  getAccountInfo,
  getPlans,
  updateModulesSettings,
  getConfirmURL,
} from '@/service/account'

const PAYMENT_METHOD_CREDIT_CARD = 'credit_card'
const PAYMENT_METHOD_BOLETO = 'boleto'
export const PERIODS = {
  MONTHLY: 'monthly',
  ANNUITY: 'annuity',
}
export const PLANS_TYPE = {
  BASIC: 'basic',
  ENTERPRISE: 'enterprise',
  TRIAL: 'trial',
}

function initialState() {
  const savedState = sessionStorage.accountState
    ? JSON.parse(sessionStorage.accountState)
    : {}

  return Object.assign(
    {
      settings: {
        surveyIntervalDays: 'weekly',
        deliverySurveyDate: null,
        modules: {
          engagement: false,
          culture: false,
          customSurvey: false,
        },
      },
      since: null,
      billing: {
        plan: 'Básico',
      },
      licenses: 0,
      licensesPlan: {
        licenses: 11,
        price: 8.9,
        discountPerUser: 0,
        period: false,
        planType: 'enterprise',
      },
      paymentMethod: {
        type: PAYMENT_METHOD_BOLETO,
        number: '**** **** **** ****'.replace(/\*/g, '•'),
        cvv: '***'.replace(/\*/g, '•'),
        name: 'Axel Lotte ',
        validate: '14/05',
        brand: 'visa',
      },
      plans: [],
      enterprisePlan: {
        monthly: {
          period: 'monthly',
          price: 8.9,
          discountPerUser: 0,
        },
        annuity: {
          period: 'annuity',
          price: 8.9,
          discountPerUser: 3,
        },
      },
    },
    savedState
  )
}

const state = initialState()

const getters = {
  since: state => state.since,
  plans: state => state.plans,
  billing: state => state.billing,
  licenses: state => state.licenses,
  licensesPlan: state => state.licensesPlan,
  paymentMethod: state => state.paymentMethod,
  isCreditCardMethod: state =>
    state.paymentMethod.type === PAYMENT_METHOD_CREDIT_CARD,
  isBoletoMethod: state => state.paymentMethod.type === PAYMENT_METHOD_BOLETO,
  openModalAlterLicenses: state => state.openModalAlterLicenses,
  settings: state => state.settings,
}

const mutations = {
  SET_SINCE: (state, since) => (state.since = since),
  SET_BILLING: (state, billing) => (state.billing = Object.assign({}, billing)),
  SET_LICENSES_PLAN: (state, licensesPlan) =>
    (state.licensesPlan = Object.assign({}, licensesPlan, {
      licenses: state.licenses,
    })),
  SET_CHOSEN_PLAN: (state, plan) =>
    (state.licensesPlan = Object.assign({}, state.licensesPlan, plan)),
  SET_LICENSES: (state, licenses) => (state.licenses = licenses),
  SET_MODAL_STATE: (state, modalStateOpen) =>
    (state.openModalAlterLicenses = modalStateOpen),
  SET_PAYMENT_METHOD: (state, paymentMethod) => {
    if (paymentMethod.item_type === PAYMENT_METHOD_CREDIT_CARD) {
      state.paymentMethod = Object.assign({
        type: paymentMethod.item_type,
        number: paymentMethod.data.display_number
          .replace(/X/g, '•')
          .replace(/-/g, ' '),
        cvv: '***'.replace(/\*/g, '•'),
        name: paymentMethod.data.holder_name,
        validate: `${paymentMethod.data.month}/${paymentMethod.data.year}`,
        brand: paymentMethod.data.brand,
      })
    }

    state.paymentMethod = Object.assign(
      {},
      state.paymentMethod,
      { type: paymentMethod.item_type },
      paymentMethod
    )
  },
  SET_PLANS: (state, plans) => {
    state.plans = plans
  },
  SET_MODULES_SETTINGS(state, accountInfo) {
    const { surveyIntervalDays, deliverySurveyDate, modules } = accountInfo
    Object.assign(state.settings, {
      surveyIntervalDays,
      deliverySurveyDate,
      modules,
    })
  },
  UPDATE_SETTINGS(state, { field, value }) {
    state.settings[field] = value
  },
  UPDATE_MODULES_SETTINGS(state, { field, value }) {
    state.settings.modules[field] = value
  },
}

const saveState = state => {
  sessionStorage.accountState = JSON.stringify(state)
}

const actions = {
  async saveSettings(_, settings) {
    return await updateModulesSettings(settings)
  },

  changeModulesSettings({ commit }, { field, value }) {
    commit('UPDATE_MODULES_SETTINGS', { field, value })
  },

  changeSettings({ commit }, { field, value }) {
    commit('UPDATE_SETTINGS', { field, value })
  },

  loadConfirmURL: async () => {
    const confirmToken = await getConfirmURL()
    const confirmURL = `${window.location.protocol}//${window.location.hostname}/login/confirm-account/${confirmToken.token}`

    // eslint-disable-next-line no-console
    console.log(confirmURL)
  },

  loadSubscriptions: async ({ commit, state }) => {
    try {
      const accountInfo = ((await getAccountInfo()) || {}).data
      commit('SET_SINCE', accountInfo.since)
      commit('SET_BILLING', accountInfo.billing)
      commit('SET_MODULES_SETTINGS', accountInfo)

      if (accountInfo.paymentMethod) {
        commit('SET_PAYMENT_METHOD', accountInfo.paymentMethod)
      }

      saveState(state)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },

  loadPlans: async ({ commit, state }) => {
    try {
      const response = ((await getPlans()) || {}).data
      commit('SET_PLANS', response.plans)
      saveState(state)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },

  loadLicensesForPlan: ({ commit, state }, period = PERIODS.MONTHLY) => {
    const enterprisePlan = state.plans.find(
      ({ id }) => id === PLANS_TYPE.ENTERPRISE
    )
    const price = enterprisePlan.prices.find(price => price.period === period)
      .pricePerUser
    const enterprisePrice = { id: PLANS_TYPE.ENTERPRISE, period, price }

    if (!state.licensesPlan.period) {
      commit(
        'SET_LICENSES_PLAN',
        Object.assign({}, state.licensesPlan, enterprisePrice)
      )
      saveState(state)
    }
  },

  setPlan: ({ commit, state }, plan) => {
    plan.discountPerUser = plan.period === PERIODS.ANNUITY ? 3 : 0
    commit('SET_CHOSEN_PLAN', Object.assign({}, plan))
    saveState(state)
  },

  setModalState: ({ commit }, stateOpen) => {
    commit('SET_MODAL_STATE', stateOpen)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
